import { render, staticRenderFns } from "./ListLeadForm.vue?vue&type=template&id=519a04c7&scoped=true&"
import script from "./ListLeadForm.vue?vue&type=script&lang=js&"
export * from "./ListLeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a04c7",
  null
  
)

export default component.exports